import type { BrowserAuthOptions as MsalBrowserAuthOptions } from '@azure/msal-browser';

import { paths } from 'src/routes/paths';

import packageJson from '../package.json';

// ----------------------------------------------------------------------

export type ConfigValue = {
  appName: string;
  appVersion: string;
  serverUrl: string;
  assetsDir: string;
  auth: {
    skip: boolean;
    redirectPath: string;
  };
  mapboxApiKey: string;
  msal: {
    auth: MsalBrowserAuthOptions;
    scopes: string[];
  };
};

// ----------------------------------------------------------------------

export const CONFIG: ConfigValue = {
  appName: 'Diamond',
  appVersion: packageJson.version,
  serverUrl: import.meta.env.VITE_SERVER_URL ?? '',
  assetsDir: import.meta.env.VITE_ASSETS_DIR ?? '',
  /**
   * Auth
   */
  auth: {
    skip: false,
    redirectPath: paths.dashboard.root,
  },
  /**
   * Mapbox
   */
  mapboxApiKey: import.meta.env.VITE_MAPBOX_API_KEY ?? '',
  /**
   * Microsoft Entra
   */
  msal: {
    auth: {
      clientId: import.meta.env.VITE_MSAL_CLIENT_ID,
      authority: import.meta.env.VITE_MSAL_AUTHORITY,
      redirectUri: paths.auth.authRedirect,
      postLogoutRedirectUri: paths.auth.authLogout,
    },
    scopes: (import.meta.env.VITE_API_SCOPE ?? '') !== '' ? [import.meta.env.VITE_API_SCOPE] : [],
  },
};
